module.exports = __webpack_public_path__ + "img/RB.59147239.png";